<app-loading *ngIf="cargando"></app-loading>
<div *ngIf="!cargando">
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate>
    <div class="grid form-group">
      <div class="col-12 md:col-4">
        <div class="div-form">
          <label>* {{ 'GARANTIASIDONEAS.LBL_PERFILRIESGO' | translate }}</label>
          <p-dropdown disableTab  id="idPerfilRiesgo" name="idPerfilRiesgo" placeholder="{{ 'LBL_SELECCIONE' | translate }}"
            [options]="lisPerfiles"  filter="filter"
                      emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label" *ngIf="!f.idGarantiaIdoneaCobroPerfilRiesgo.value"
            formControlName="idPerfilRiesgo"></p-dropdown>
          <label class="falso-combo-texto"
            *ngIf="f.idGarantiaIdoneaCobroPerfilRiesgo.value">{{regSeleccionado?.codigoPerfilRiesgo + ' - ' +
            regSeleccionado?.perfilRiesgo}}</label>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idPerfilRiesgo.invalid">
            {{ 'GARANTIASIDONEAS.LBL_PERFILRIESGO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-2">
        <div class="div-form">
          <label>* {{ 'GARANTIASIDONEAS.LBL_MONTOINICIAL' | translate }}</label>
          <input type="text" pInputText id="montoInicial" name="montoInicial" autocomplete="new-password"
            numero-decimal-reactive [entero]="7" [decimales]="6" formControlName="montoInicial"
            (change)="formateoRango(f.montoInicial.value); validarValorMaximo();">
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.montoInicial.invalid">
            {{ 'GARANTIASIDONEAS.LBL_MONTOINICIAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-2">
        <div class="div-form">
          <label>* {{ 'GARANTIASIDONEAS.LBL_MONTOFINAL' | translate }}</label>
          <input type="text" pInputText id="montoFinal" name="montoFinal" autocomplete="new-password"
            numero-decimal-reactive [entero]="7" [decimales]="6" formControlName="montoFinal"
            (change)="formateoRango(f.montoFinal.value); validarValorMaximo();">
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.montoFinal.invalid">
            {{ 'GARANTIASIDONEAS.LBL_MONTOFINAL' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
          <div class="p-message p-messages-error p-corner-all" *ngIf="!validarMaximo">
            {{ 'GARANTIASIDONEAS.MSG_RANGOMAXIMO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-2">
        <div class="div-form">
          <label>* {{ 'GARANTIASIDONEAS.LBL_COBRO' | translate }}</label>
          <input type="text" pInputText id="idPorcentajeCobro" name="nomPorcentajeCobro" autocomplete="new-password"
            numero-decimal-reactive [minimo]="0" [decimales]="6" formControlName="porcentajeCobro" [maxlength]="10"
            [maximo]="100">
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.porcentajeCobro.invalid">
            {{ 'GARANTIASIDONEAS.LBL_COBRO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-2">
        <div class="div-form">
          <label>* {{ 'GARANTIASIDONEAS.LBL_COMODIN' | translate }}</label>
          <p-dropdown disableTab  id="idComodinPlanCargo" name="idComodinPlanCargo" placeholder="{{ 'LBL_SELECCIONE' | translate }}"
            [options]="lisPlanCargoComodin"  filter="filter"
                      emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label" formControlName="idComodinPlanCargo"></p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idComodinPlanCargo.invalid">
            {{ 'GARANTIASIDONEAS.LBL_COMODIN' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
    </div>
    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <a (click)="regresar(formulario.dirty)" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
        <button icon="fa fa-plus" label="{{(regSeleccionado ? 'BTN_ACTUALIZAR' : 'BTN_AGREGAR') | translate }}"
          type="button" (click)="onSubmit()" pButton></button>
      </div>
    </div>
  </form>

  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" [value]="listado" [paginator]="true" [rows]="10"
        paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort"
              class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.codigoPerfilRiesgo}} - {{row.perfilRiesgo}}</td>
            <td>{{row.montoInicial}}</td>
            <td>{{row.montoFinal}}</td>
            <td>{{row.porcentajeCobro}}</td>
            <td>{{row.comodinPlanCargo}}</td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                  title="{{'BTN_EDITAR' | translate}}" pButton (click)="editar(row)"></button>
                <button type="button" class="red-btn p-button p-button-success btn" icon="fa fa-trash"
                  data-toggle="tooltip" title="{{'BTN_INHABILITAR' | translate}}" pButton style="background: red;"
                  (click)="inhabilitar(row)"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>

<p-confirmDialog #cd key="garantia-idonea-cobros-perfiles">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
